<template>
    <div>
        <p>
            <button class="btn btn-secondary btn-sm" type="button" @click.prevent="add"><span class="bi bi-plus-circle me-1"></span> Add</button>
        </p>
        <div class="list-of-fieldsets" v-for="(degree, key) in degrees">
            <div class="row gx-3">
                <div class="col-sm-11">
                    <div class="row gx-3">
                        <div class="col-sm-6 mb-3">
                            <label class="form-label" :for="'degree_exact_title_of_the_degree_' + key">Exact Title of the Degree</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'degrees.exact_title_of_the_degree.' + key in invalidData }"
                                type="text"
                                v-model="degree.exact_title_of_the_degree"
                                name="degrees[exact_title_of_the_degree][]"
                                :id="'degree_exact_title_of_the_degree_' + key"
                            />
                            <div class="invalid-feedback" v-if="'degrees.exact_title_of_the_degree.' + key in invalidData">
                                {{ invalidData['degrees.exact_title_of_the_degree.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <label class="form-label" :for="'degree_name_of_higher_education_institution_' + key">Name of Higher Education Institution</label>
                            <input
                                class="form-control"
                                :class="{
                                    'is-invalid': 'degrees.name_of_higher_education_institution.' + key in invalidData,
                                }"
                                type="text"
                                v-model="degree.name_of_higher_education_institution"
                                name="degrees[name_of_higher_education_institution][]"
                                :id="'degree_name_of_higher_education_institution_' + key"
                            />
                            <div class="invalid-feedback" v-if="'degrees.name_of_higher_education_institution.' + key in invalidData">
                                {{ invalidData['degrees.name_of_higher_education_institution.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <label class="form-label" :for="'degree_city_' + key">City</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'degrees.city.' + key in invalidData }"
                                type="text"
                                v-model="degree.city"
                                name="degrees[city][]"
                                :id="'degree_city_' + key"
                            />
                            <div class="invalid-feedback" v-if="'degrees.city.' + key in invalidData">
                                {{ invalidData['degrees.city.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <label class="form-label" :for="'degree_country_' + key">Country</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'degrees.country.' + key in invalidData }"
                                type="text"
                                v-model="degree.country"
                                name="degrees[country][]"
                                :id="'degree_country_' + key"
                            />
                            <div class="invalid-feedback" v-if="'degrees.country.' + key in invalidData">
                                {{ invalidData['degrees.country.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <label class="form-label" :for="'degree_date_of_first_enrollment_' + key">Date of First Enrollment</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'degrees.date_of_first_enrollment.' + key in invalidData }"
                                type="date"
                                v-model="degree.date_of_first_enrollment"
                                name="degrees[date_of_first_enrollment][]"
                                :id="'degree_date_of_first_enrollment_' + key"
                            />
                            <div class="invalid-feedback" v-if="'degrees.date_of_first_enrollment.' + key in invalidData">
                                {{ invalidData['degrees.date_of_first_enrollment.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <label class="form-label" :for="'degree_graduation_date_' + key">Graduation Date</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'degrees.graduation_date.' + key in invalidData }"
                                type="month"
                                minlength="7"
                                maxlength="7"
                                v-model="degree.graduation_date"
                                name="degrees[graduation_date][]"
                                :id="'degree_graduation_date_' + key"
                            />
                            <div class="invalid-feedback" v-if="'degrees.graduation_date.' + key in invalidData">
                                {{ invalidData['degrees.graduation_date.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 mb-3">
                            <label class="form-label" :for="'degree_number_of_years_studied_in_number_of_months_' + key">Number of Years Studied (in Number of Months)</label>
                            <input
                                class="form-control"
                                :class="{
                                    'is-invalid': 'degrees.number_of_years_studied_in_number_of_months.' + key in invalidData,
                                }"
                                type="number"
                                v-model="degree.number_of_years_studied_in_number_of_months"
                                name="degrees[number_of_years_studied_in_number_of_months][]"
                                :id="'degree_number_of_years_studied_in_number_of_months_' + key"
                            />
                            <div class="invalid-feedback" v-if="'degrees.number_of_years_studied_in_number_of_months.' + key in invalidData">
                                {{ invalidData['degrees.number_of_years_studied_in_number_of_months.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 mb-3">
                            <label class="form-label" :for="'degree_number_of_study_credits_awarded_' + key">Number of Study Credits Awarded</label>
                            <input
                                class="form-control"
                                :class="{
                                    'is-invalid': 'degrees.number_of_study_credits_awarded.' + key in invalidData,
                                }"
                                type="number"
                                v-model="degree.number_of_study_credits_awarded"
                                name="degrees[number_of_study_credits_awarded][]"
                                :id="'degree_number_of_study_credits_awarded_' + key"
                            />
                            <div class="invalid-feedback" v-if="'degrees.number_of_study_credits_awarded.' + key in invalidData">
                                {{ invalidData['degrees.number_of_study_credits_awarded.' + key][0] }}
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-4 mb-3">
                            <label class="form-label" :for="'degree_name_of_study_credits_awarded_' + key">Name of study Credits Awarded – e.g. ECTS</label>
                            <input
                                class="form-control"
                                :class="{ 'is-invalid': 'degrees.name_of_study_credits_awarded.' + key in invalidData }"
                                type="text"
                                v-model="degree.name_of_study_credits_awarded"
                                name="degrees[name_of_study_credits_awarded][]"
                                :id="'degree_name_of_study_credits_awarded_' + key"
                            />
                            <div class="invalid-feedback" v-if="'degrees.name_of_study_credits_awarded.' + key in invalidData">
                                {{ invalidData['degrees.name_of_study_credits_awarded.' + key][0] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-1 mb-3 d-flex align-items-end">
                    <button class="btn btn-link text-danger" type="button" @click.prevent="remove(degree)">Remove</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        initDegrees: {
            type: Array,
            required: true,
        },
        invalidData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            degrees: this.initDegrees,
        };
    },
    methods: {
        newDegree() {
            return {
                exact_title_of_the_degree: '',
                name_of_higher_education_institution: '',
                city: '',
                country: '',
                date_of_first_enrollment: '',
                graduation_date: '',
                number_of_years_studied_in_number_of_months: '',
                number_of_study_credits_awarded: '',
                name_of_study_credits_awarded: '',
            };
        },
        add() {
            this.degrees.push(this.newDegree());
        },
        remove(degree) {
            var index = this.degrees.indexOf(degree);
            this.degrees.splice(index, 1);
        },
    },
};
</script>
